
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/landlord-certificate",
      function () {
        return require("private-next-pages/services/landlord-certificate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/landlord-certificate"])
      });
    }
  